global.GLAS = {
    branch: 'glas',
    // dry-run marker:
    dry: true,
    o_possible: true,
    type: 'glas',

    canCalc: function(e) {
        BC.debug('GLAS.canCalc(): Checking ...', '', 64);
        PRIV.calcable = GLAS.havePeril();
        return PRIV.calcable;
    },

    change: function(e) {
	BC.debug('GLAS.change()', e, 64);
	if (ALL.chkChkBox('f_' + GLAS.type + '_dnls')) {
            ALL.chkDate(JQ('#f_' + GLAS.type + '_ende'));
        }
	if (! GLAS.canCalc(e)) {
	    ALL.chgProduct('glas', null);
	    ALL.notifyHeight();
	    return;
	}
	GLAS.haveInfo();
	GLAS.recalc();
	ALL.notifyHeight();
    },

    haveInfo: function(e) {
	GLAS.o_possible = Boolean(JQ('#f_' + GLAS.type + '_plz').val() &&
				  JQ('#f_' + GLAS.type + '_ort').val() &&
				  JQ('#f_' + GLAS.type + '_str').val() &&
				  JQ('#f_' + GLAS.type + '_hnr').val());
	JQ('#b_' +  GLAS.type + '_go2datavn').button("option", "disabled", ! GLAS.o_possible || parseInt(JQ('#f_'+GLAS.type+'_rbt_bundle').find('option:selected').val()) >= 5 && JQ('#f_'+GLAS.type+'_rbt_bundle_text').val().length === 0);
	GLAS.o_possible ? JQ('#a_' + GLAS.type + '_da').show() : JQ('#a_' + GLAS.type + '_da').hide();
        if (parseInt(JQ('#f_'+GLAS.type+'_rbt_bundle').find('option:selected').val()) >= 5 && JQ('#f_'+GLAS.type+'_rbt_bundle_text').val().length === 0) {
            JQ('#vs-nr-hint-' + GLAS.type).show();
        } else {
            JQ('#vs-nr-hint-' + GLAS.type).hide();
        }
        BC.debug('GLAS.haveInfo() => ', GLAS.o_possible, 64);
        ALL.notifyHeight();
        return GLAS.o_possible;
    },

    havePeril: function() {
        BC.debug('GLAS.havePeril(): Checking ...', '', 128);
        var valid = false;
        PRIV.bparts['glas'] = [];
        var gl_we = parseInt(JQ('#f_glas_we').val());
        var gl_wf = parseInt(JQ('#f_glas_wf').val());
        var gl_wf2 = parseInt(JQ('#f_glas_wf2').val());
        JQ.each(['efh', 'mfh', 'whg'], function(i, v) {
            if (! JQ("#f_glas_" + v).is(':checked')) {
            JQ('#f_glas_net2_' + v).text('0,00 €');
            JQ('#div_glas_' + v + '_1').hide();
            } else {
            JQ('#div_glas_' + v + '_1').show();
            }
        });
        if (JQ('#f_glas_efh').is(':checked') && gl_wf && JQ("#div_glas_efh input[name='glas_efh0']").is(':checked')) {
            valid = true;
            JQ('#f_glas_mfh').prop('checked', false);
            JQ('#f_glas_whg').prop('checked', false);
        } else if (JQ('#f_glas_mfh').is(':checked') && gl_we && JQ("#div_glas_mfh input[name='glas_mfh0']").is(':checked')) {
            valid = true;
            JQ('#f_glas_efh').prop('checked', false);
            JQ('#f_glas_whg').prop('checked', false);
        } else if (JQ('#f_glas_whg').is(':checked') && gl_wf2 && JQ("#div_glas_whg input[name='glas_whg0']").is(':checked')) {
            valid = true;
            JQ('#f_glas_efh').prop('checked', false);
            JQ('#f_glas_mfh').prop('checked', false);
        }
        BC.debug('GLAS.havePeril(): => ', valid, 64);
        return valid;
    },

    init: function() {
	BC.debug('GLAS.init():', '', 64);
	    PRIV.hideLogoutAndAdministration();
        PRIV.createBundleRabattFieldsForBranch('glas')
    },

    recalc: function(e) {
	BC.debug('GLAS.recalc():', '', 256);
	if (! GLAS.canCalc()) {
	    BC.debug('GLAS.recalc():', 'Cannot calc - check logs!', 128);
	    return;
	}
	var sa = PRIV.make_sa('glas');
	BC.debug('GLAS.recalc():', sa, 64);
	JQ.getJSON(JSONURI, sa, PRIV.setPremium);
	ALL.chkContactData();
	ALL.notifyHeight();
    },

};